import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "4:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-385.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "4:2": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-385.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "4:3": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-385.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "4:4": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-385.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
};

export default components;
